export default "__VITE_ASSET__CzoT9ZWj__"